import { render, staticRenderFns } from "./MobileCommunityHealthInfoCreate.vue?vue&type=template&id=d7413c90&"
import script from "./MobileCommunityHealthInfoCreate.vue?vue&type=script&lang=js&"
export * from "./MobileCommunityHealthInfoCreate.vue?vue&type=script&lang=js&"
import style0 from "./MobileCommunityHealthInfoCreate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports